/* eslint-disable local-rules/scoped-modules */
// import { init as initCommonExternals } from './common';
import { init as initOnboardingExternals } from './onboarding';
import { init as initOpenappExternals } from './openapp';
import { init as initAutomationExternals } from './automation';
import { init as initMetricExternals } from './metrics';

export const init = () => {
  // initCommonExternals();
  initOnboardingExternals();
  initOpenappExternals();
  initAutomationExternals();
  initMetricExternals();
};
